import * as actions from '../constants/actions';

const initialState = {
  regions: {},
  regionsNow: {},
  selected: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_REGIONS_RECEIVE:
      return {
        ...state,
        regions: action.result,
        regionsNow: (!action.timeSpan || action.timeSpan === 'now') ?
          action.result : state.regionsNow,
      };
    case actions.SELECT_REGION:
      return { ...state, selected: action.region };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/regions.js